import { PageContainer } from "@/components/layout/PageContainer";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Mail, MessageSquare, Building2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { GeneralContactDialog } from "@/components/contact/GeneralContactDialog";

export default function Contact() {
  const navigate = useNavigate();
  const [showGeneralContact, setShowGeneralContact] = useState(false);

  const contactOptions = [
    {
      title: "Sales Inquiries",
      description: "Talk to our sales team about enterprise solutions and pricing",
      icon: Building2,
      action: () => navigate("/contact-sales"),
      dataTestId: "sales-contact",
    },
    {
      title: "Technical Support",
      description: "Get help with technical issues and platform questions",
      icon: MessageSquare,
      action: () => navigate("/support"),
      dataTestId: "support-contact",
    },
    {
      title: "General Inquiries",
      description: "Questions about our company or other topics",
      icon: Mail,
      action: () => setShowGeneralContact(true),
      dataTestId: "general-contact",
    },
  ];

  return (
    <PageContainer>
      <div className="max-w-4xl mx-auto space-y-8 py-12">
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-bold">Contact Us</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Choose how you'd like to get in touch with us. We're here to help!
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {contactOptions.map((option) => (
            <Card
              key={option.title}
              className="p-6 hover:shadow-lg transition-shadow cursor-pointer"
              onClick={option.action}
              data-testid={option.dataTestId}
            >
              <div className="space-y-4">
                <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-4">
                  <option.icon className="w-6 h-6 text-primary" />
                </div>
                <h2 className="text-xl font-semibold">{option.title}</h2>
                <p className="text-gray-600">{option.description}</p>
                <Button className="w-full">
                  Contact {option.title.split(" ")[0]}
                </Button>
              </div>
            </Card>
          ))}
        </div>
      </div>

      <GeneralContactDialog 
        open={showGeneralContact} 
        onOpenChange={setShowGeneralContact}
      />
    </PageContainer>
  );
}